export const mockData = {
  ipoCalendar: [
    {
      date: '2020-05-01',
      exchange: 'Estalee Capital',
      name: 'Estalee',
      numberOfShares: 15000000000,
      price: '10.00',
      status: 'priced',
      symbol: 'ESTA',
      totalSharesValue: 150000000000,
    },
    {
      date: '2020-05-01',
      exchange: 'NASDAQ Global',
      name: 'Lyra Therapeutics, Inc.',
      numberOfShares: 3500000,
      price: '16.00',
      status: 'priced',
      symbol: 'LYRA',
      totalSharesValue: 56000000,
    },
    {
      date: '2020-05-01',
      exchange: null,
      name: 'EQUITABLE MINERAL \u0026 DEVELOPMENT, INC.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: '',
      totalSharesValue: 15000000,
    },
    {
      date: '2020-05-01',
      exchange: null,
      name: 'Longview Acquisition Corp.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'LGVWU',
      totalSharesValue: 360000000,
    },
    {
      date: '2020-04-30',
      exchange: null,
      name: 'Vontier Corp',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-04-30',
      exchange: 'NYSE',
      name: 'Fortress Value Acquisition Corp.',
      numberOfShares: 30000000,
      price: '10.00',
      status: 'priced',
      symbol: 'FVACU',
      totalSharesValue: 300000000,
    },
    {
      date: '2020-04-28',
      exchange: 'NYSE',
      name: 'Social Capital Hedosophia Holdings Corp. II',
      numberOfShares: 36000000,
      price: '10.00',
      status: 'priced',
      symbol: 'IPOBU',
      totalSharesValue: 360000000,
    },
    {
      date: '2020-04-24',
      exchange: null,
      name: 'Father Time, Inc.',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-04-24',
      exchange: null,
      name: 'SeqLL, Inc.',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-04-24',
      exchange: 'NASDAQ Global Select',
      name: 'Oric Pharmaceuticals, Inc.',
      numberOfShares: 7500000,
      price: '16.00',
      status: 'priced',
      symbol: 'ORIC',
      totalSharesValue: 120000000,
    },
    {
      date: '2020-04-24',
      exchange: 'NYSE',
      name: 'CC Neuberger Principal Holdings I',
      numberOfShares: 36000000,
      price: '10.00',
      status: 'priced',
      symbol: 'PCPLU',
      totalSharesValue: 360000000,
    },
    {
      date: '2020-04-24',
      exchange: 'NYSE MKT',
      name: 'Chardan Healthcare Acquisition 2 Corp.',
      numberOfShares: 8500000,
      price: '10.00',
      status: 'priced',
      symbol: 'CHAQU',
      totalSharesValue: 85000000,
    },
    {
      date: '2020-04-22',
      exchange: 'NYSE',
      name: 'Social Capital Hedosophia Holdings Corp. III',
      numberOfShares: 72000000,
      price: '10.00',
      status: 'priced',
      symbol: 'IPOCU',
      totalSharesValue: 720000000,
    },
    {
      date: '2020-04-15',
      exchange: null,
      name: 'STARGUIDE GROUP, INC.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: '',
      totalSharesValue: 150000,
    },
    {
      date: '2020-04-08',
      exchange: 'NASDAQ Global',
      name: 'Keros Therapeutics, Inc.',
      numberOfShares: 6000000,
      price: '16.00',
      status: 'priced',
      symbol: 'KROS',
      totalSharesValue: 96000000,
    },
    {
      date: '2020-04-08',
      exchange: null,
      name: 'HYGGE INTEGRATED BRANDS CORP.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: '',
      totalSharesValue: 24275,
    },
    {
      date: '2020-04-07',
      exchange: null,
      name: 'To Prosperity Technology Inc',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-04-03',
      exchange: 'NASDAQ Global',
      name: 'Zentalis Pharmaceuticals, Inc.',
      numberOfShares: 9180000,
      price: '18.00',
      status: 'priced',
      symbol: 'ZNTL',
      totalSharesValue: 165240000,
    },
    {
      date: '2020-04-01',
      exchange: 'NASDAQ Global',
      name: 'WiMi Hologram Cloud Inc.',
      numberOfShares: 4750000,
      price: '5.50',
      status: 'priced',
      symbol: 'WIMI',
      totalSharesValue: 26125000,
    },
    {
      date: '2020-03-18',
      exchange: null,
      name: 'UTime Ltd',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'UTME',
      totalSharesValue: 21562500,
    },
    {
      date: '2020-03-13',
      exchange: null,
      name: 'Leaping Group Co., Ltd.',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-03-12',
      exchange: 'NASDAQ Global Select',
      name: 'IMARA Inc.',
      numberOfShares: 4700000,
      price: '16.00',
      status: 'priced',
      symbol: 'IMRA',
      totalSharesValue: 75200000,
    },
    {
      date: '2020-03-11',
      exchange: 'NASDAQ Capital',
      name: 'DFP HEALTHCARE ACQUISITIONS CORP.',
      numberOfShares: 20000000,
      price: '10.00',
      status: 'priced',
      symbol: 'DFPHU',
      totalSharesValue: 200000000,
    },
    {
      date: '2020-03-06',
      exchange: 'NASDAQ Capital',
      name: 'LifeSci Acquisition Corp.',
      numberOfShares: 6000000,
      price: '10.00',
      status: 'priced',
      symbol: 'LSACU',
      totalSharesValue: 60000000,
    },
    {
      date: '2020-03-06',
      exchange: 'NYSE',
      name: 'Flying Eagle Acquisition Corp.',
      numberOfShares: 60000000,
      price: '10.00',
      status: 'priced',
      symbol: 'FEACU',
      totalSharesValue: 600000000,
    },
    {
      date: '2020-03-06',
      exchange: null,
      name: 'WeTrade Group Inc.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: '',
      totalSharesValue: 991011,
    },
    {
      date: '2020-03-05',
      exchange: null,
      name: 'SAFE AUTO INSURANCE GROUP, INC.',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-03-04',
      exchange: null,
      name: 'Meten International Education Group',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-03-03',
      exchange: 'NYSE',
      name: 'GFL Environmental Inc.',
      numberOfShares: 75000000,
      price: '19.00',
      status: 'priced',
      symbol: 'GFL',
      totalSharesValue: 1425000000,
    },
    {
      date: '2020-02-28',
      exchange: null,
      name: 'PROCORE TECHNOLOGIES, INC.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'PCOR',
      totalSharesValue: 100000000,
    },
    {
      date: '2020-02-24',
      exchange: 'NASDAQ Capital',
      name: 'Zhongchao Inc.',
      numberOfShares: 3000000,
      price: '4.00',
      status: 'priced',
      symbol: 'ZCMD',
      totalSharesValue: 12000000,
    },
    {
      date: '2020-02-21',
      exchange: 'NYSE',
      name: 'dMY Technology Group, Inc.',
      numberOfShares: 20000000,
      price: '10.00',
      status: 'priced',
      symbol: 'DMYTU',
      totalSharesValue: 200000000,
    },
    {
      date: '2020-02-21',
      exchange: null,
      name: 'GOLDENWELL BIOTECH, INC.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: '',
      totalSharesValue: 80000,
    },
    {
      date: '2020-02-20',
      exchange: 'NASDAQ Capital',
      name: 'East Stone Acquisition Corp',
      numberOfShares: 12000000,
      price: '10.00',
      status: 'priced',
      symbol: 'ESSCU',
      totalSharesValue: 120000000,
    },
    {
      date: '2020-02-19',
      exchange: null,
      name: 'EnVen Energy Corp',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-02-18',
      exchange: null,
      name: 'Freecast, Inc.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'FCST',
      totalSharesValue: 17250000,
    },
    {
      date: '2020-02-14',
      exchange: 'NASDAQ Capital',
      name: 'Newborn Acquisition Corp',
      numberOfShares: 5000000,
      price: '10.00',
      status: 'priced',
      symbol: 'NBACU',
      totalSharesValue: 50000000,
    },
    {
      date: '2020-02-14',
      exchange: 'NYSE',
      name: 'Churchill Capital Corp III',
      numberOfShares: 100000000,
      price: '10.00',
      status: 'priced',
      symbol: 'CCXXU',
      totalSharesValue: 1000000000,
    },
    {
      date: '2020-02-13',
      exchange: null,
      name: 'Northridge Corp',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-02-13',
      exchange: 'NASDAQ Global Select',
      name: 'Revolution Medicines, Inc.',
      numberOfShares: 14000000,
      price: '17.00',
      status: 'priced',
      symbol: 'RVMD',
      totalSharesValue: 238000000,
    },
    {
      date: '2020-02-13',
      exchange: 'NASDAQ Capital',
      name: 'TRXADE GROUP, INC.',
      numberOfShares: 806452,
      price: '6.50',
      status: 'priced',
      symbol: 'MEDS',
      totalSharesValue: 5241938,
    },
    {
      date: '2020-02-13',
      exchange: 'NASDAQ Capital',
      name: 'Muscle Maker, Inc.',
      numberOfShares: 1540000,
      price: '5.00',
      status: 'priced',
      symbol: 'GRIL',
      totalSharesValue: 7700000,
    },
    {
      date: '2020-02-13',
      exchange: 'NASDAQ Capital',
      name: 'Yunhong International',
      numberOfShares: 6000000,
      price: '10.00',
      status: 'priced',
      symbol: 'ZGYHU',
      totalSharesValue: 60000000,
    },
    {
      date: '2020-02-12',
      exchange: 'NASDAQ Global',
      name: 'Huize Holding Ltd',
      numberOfShares: 5250000,
      price: '10.50',
      status: 'priced',
      symbol: 'HUIZ',
      totalSharesValue: 55125000,
    },
    {
      date: '2020-02-11',
      exchange: 'NYSE',
      name: 'CITIC Capital Acquisition Corp.',
      numberOfShares: 24000000,
      price: '10.00',
      status: 'priced',
      symbol: 'CCACU',
      totalSharesValue: 240000000,
    },
    {
      date: '2020-02-11',
      exchange: 'NASDAQ Capital',
      name: 'Greenrose Acquisition Corp.',
      numberOfShares: 15000000,
      price: '10.00',
      status: 'priced',
      symbol: 'GNRSU',
      totalSharesValue: 150000000,
    },
    {
      date: '2020-02-11',
      exchange: null,
      name: 'Pelican Delivers, Inc.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: '',
      totalSharesValue: 7800000,
    },
    {
      date: '2020-02-11',
      exchange: null,
      name: 'Alpha Investment Inc.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: '',
      totalSharesValue: 17250000,
    },
    {
      date: '2020-02-07',
      exchange: 'NASDAQ Global Select',
      name: 'Professional Holding Corp.',
      numberOfShares: 3100000,
      price: '18.50',
      status: 'priced',
      symbol: 'PFHD',
      totalSharesValue: 57350000,
    },
    {
      date: '2020-02-07',
      exchange: 'NYSE',
      name: 'NexPoint Real Estate Finance, Inc.',
      numberOfShares: 5000000,
      price: '19.00',
      status: 'priced',
      symbol: 'NREF',
      totalSharesValue: 95000000,
    },
    {
      date: '2020-02-07',
      exchange: 'NASDAQ Global',
      name: 'OneWater Marine Inc.',
      numberOfShares: 4615385,
      price: '12.00',
      status: 'priced',
      symbol: 'ONEW',
      totalSharesValue: 55384620,
    },
    {
      date: '2020-02-06',
      exchange: 'NASDAQ Global Select',
      name: 'PPD, Inc.',
      numberOfShares: 60000000,
      price: '27.00',
      status: 'priced',
      symbol: 'PPD',
      totalSharesValue: 1620000000,
    },
    {
      date: '2020-02-06',
      exchange: 'NYSE',
      name: 'Casper Sleep Inc.',
      numberOfShares: 8350000,
      price: '12.00',
      status: 'priced',
      symbol: 'CSPR',
      totalSharesValue: 100200000,
    },
    {
      date: '2020-02-06',
      exchange: 'NASDAQ Global Select',
      name: 'Schrodinger, Inc.',
      numberOfShares: 11882352,
      price: '17.00',
      status: 'priced',
      symbol: 'SDGR',
      totalSharesValue: 201999984,
    },
    {
      date: '2020-02-06',
      exchange: 'NASDAQ Global Select',
      name: 'Beam Therapeutics Inc.',
      numberOfShares: 10588236,
      price: '17.00',
      status: 'priced',
      symbol: 'BEAM',
      totalSharesValue: 180000012,
    },
    {
      date: '2020-02-04',
      exchange: null,
      name: 'KCI Holdings, Inc.',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-02-04',
      exchange: 'NYSE',
      name: 'InterPrivate Acquisition Corp.',
      numberOfShares: 21000000,
      price: '10.00',
      status: 'priced',
      symbol: "IPV'U",
      totalSharesValue: 210000000,
    },
    {
      date: '2020-02-03',
      exchange: null,
      name: 'Passage BIO, Inc.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'PASG',
      totalSharesValue: 216000000,
    },
    {
      date: '2020-01-31',
      exchange: null,
      name: 'Riley Exploration - Permian, LLC',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-01-31',
      exchange: 'NASDAQ Global Select',
      name: 'Reynolds Consumer Products Inc.',
      numberOfShares: 47170000,
      price: '26.00',
      status: 'priced',
      symbol: 'REYN',
      totalSharesValue: 1226420000,
    },
    {
      date: '2020-01-30',
      exchange: null,
      name: 'iShares Gold Trust Micro',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-01-30',
      exchange: 'NASDAQ Global',
      name: 'AnPac Bio-Medical Science Co., Ltd.',
      numberOfShares: 1333360,
      price: '12.00',
      status: 'priced',
      symbol: 'ANPC',
      totalSharesValue: 16000320,
    },
    {
      date: '2020-01-29',
      exchange: 'NYSE MKT',
      name: 'Annovis Bio, Inc.',
      numberOfShares: 2000000,
      price: '6.00',
      status: 'priced',
      symbol: 'ANVS',
      totalSharesValue: 12000000,
    },
    {
      date: '2020-01-24',
      exchange: 'NASDAQ Capital',
      name: 'Gores Holdings IV, Inc.',
      numberOfShares: 40000000,
      price: '10.00',
      status: 'priced',
      symbol: 'GHIVU',
      totalSharesValue: 400000000,
    },
    {
      date: '2020-01-24',
      exchange: 'NYSE',
      name: 'SCVX Corp.',
      numberOfShares: 20000000,
      price: '10.00',
      status: 'priced',
      symbol: 'SCVXU',
      totalSharesValue: 200000000,
    },
    {
      date: '2020-01-21',
      exchange: null,
      name: 'Goxus, Inc',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'GOXS',
      totalSharesValue: 17250000,
    },
    {
      date: '2020-01-21',
      exchange: null,
      name: 'UTXO Acquisition Inc.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'UTXOU',
      totalSharesValue: 57500000,
    },
    {
      date: '2020-01-17',
      exchange: 'NYSE',
      name: 'Velocity Financial, Inc.',
      numberOfShares: 7250000,
      price: '13.00',
      status: 'priced',
      symbol: 'VEL',
      totalSharesValue: 94250000,
    },
    {
      date: '2020-01-17',
      exchange: 'NASDAQ Global Select',
      name: 'LIZHI INC.',
      numberOfShares: 4100000,
      price: '11.00',
      status: 'priced',
      symbol: 'LIZI',
      totalSharesValue: 45100000,
    },
    {
      date: '2020-01-17',
      exchange: 'NYSE',
      name: 'Phoenix Tree Holdings Ltd',
      numberOfShares: 9600000,
      price: '13.50',
      status: 'priced',
      symbol: 'DNK',
      totalSharesValue: 129600000,
    },
    {
      date: '2020-01-17',
      exchange: 'NASDAQ Global',
      name: 'I-Mab',
      numberOfShares: 7407400,
      price: '14.00',
      status: 'priced',
      symbol: 'IMAB',
      totalSharesValue: 103703600,
    },
    {
      date: '2020-01-17',
      exchange: null,
      name: 'JIANA SCIENCE \u0026 TECHNOLOGY CO., LTD.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'JANA',
      totalSharesValue: 11500000,
    },
    {
      date: '2020-01-14',
      exchange: null,
      name: 'BITWISE BITCOIN ETF TRUST',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-01-14',
      exchange: null,
      name: 'United States Gold \u0026 Treasury Investment Trust',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: '',
      totalSharesValue: 1000000,
    },
    {
      date: '2020-01-08',
      exchange: null,
      name: 'Ardent Health Partners, LLC',
      numberOfShares: null,
      price: null,
      status: 'withdrawn',
      symbol: null,
      totalSharesValue: null,
    },
    {
      date: '2020-01-06',
      exchange: null,
      name: 'Arcutis Biotherapeutics, Inc.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'ARQT',
      totalSharesValue: 159375000,
    },
    {
      date: '2020-01-03',
      exchange: null,
      name: 'Black Diamond Therapeutics, Inc.',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'BDTX',
      totalSharesValue: 201140004,
    },
    {
      date: '2020-01-03',
      exchange: null,
      name: '1life Healthcare Inc',
      numberOfShares: null,
      price: null,
      status: 'filed',
      symbol: 'ONEM',
      totalSharesValue: 245000000,
    },
  ],
}
